<template>
    <div>
        <v-select
                v-model="selected"
                :items="types[type]"
                item-text="label"
                item-value="code"
                :label="label"
                @change="update"
                :error-messages="errorMessages"
                :readonly="readonly"
        />
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
            },
            label: {
                type: String,
                default: 'Booking Type'
            },
            type: {
                type: String,
                default: 'booking',
            },
            errorMessages: {
                type: Array,
            },
            readonly: {
                type: Boolean,
                default:false
            },
        },
        data() {
            return {
                selected: this.value,
                types: {
                    booking: [
                        {code: 'A1', label: 'Training'},
                        {code: 'A2', label: 'Consultancy'},
                        {code: 'A3', label: 'Other'},
                    ],
                    training: [
                        {code: 'B2', label: 'Single Company'},
                        {code: 'B3', label: 'Public'},
                    ],
                    payment: [
                        {code: 'L1', label: 'Cheque'},
                        {code: 'L2', label: 'BACS'},
                        {code: 'L3', label: 'Credit Card'},
                        {code: 'L4', label: 'Cash'},
                        {code: 'L5', label: 'Debit Card'},
                        {code: 'L6', label: 'By Various'},
                        {code: 'L7', label: 'Other'},
                        {code: 'L8', label: 'SO'},
                    ],
                }
            }
        },
        methods: {
            update() {
                this.$emit('input', this.selected)
            }
        },
    }
</script>

<style scoped>

</style>